import React from 'react'
import { NavLink } from 'react-router-dom'
import { string, bool } from 'prop-types'
import { getQueryParameter } from 'services/utils/strings'

const SPRegister = requestOrigin => (
  <NavLink
    className="register-nav-link primary full"
    to={`/register?request_origin=${requestOrigin}${getQueryParameter('web_view') ? `&web_view=register` : ''}`}
  >
    Register
  </NavLink>
)

const ThirdPartyReg = (requestOrigin, clientId, redirectUri) => (
  <NavLink
    className="reg-link primary full"
    to={`/register?request_origin=${requestOrigin}&&client_id=${clientId}&&redirect_uri=${encodeURIComponent(redirectUri)}`}
  >
    Register
  </NavLink>
)

const BottomSection = ({
  isThirdParty,
  requestOrigin,
  clientId,
  redirectUri,
}) => (
  <div>
    <h3>New customer?</h3>
    <p>Registering is quick and easy</p>
    {isThirdParty
      ? ThirdPartyReg(requestOrigin, clientId, redirectUri)
      : SPRegister(requestOrigin)}
  </div>
)

BottomSection.propTypes = {
  isThirdParty: bool,
  requestOrigin: string,
  clientId: string,
  redirectUri: string,
}

BottomSection.defaultProps = {
  isThirdParty: false,
  requestOrigin: 'asda',
  clientId: '',
  redirectUri: '',
}

export default BottomSection
